import { Optional } from '../misc/Optional';
import { Value } from './Value';

export class LessThenOrEqual implements Value<boolean> {
	private readonly result: Optional<boolean>;

	public constructor(value1: Value<number>, value2: Value<number>) {
		this.result = calculate(value1.getSingle(), value2.getSingle());
	}

	public isRepeatable(): boolean {
		return false;
	}

	public get(): ReadonlyArray<boolean> {
		return this.result !== null ? [this.result] : [];
	}

	public getSingle(): Optional<boolean> {
		return this.result;
	}
}

function calculate(value1: Optional<number>, value2: Optional<number>): Optional<boolean> {
	if (value1 !== null && value2 !== null) {
		return value1 <= value2;
	}
	return null;
}
